import * as S from './LOSCard.styles';
import {isValidArray} from '@stencil/hotels-utils/src/common-utils';

const defaultIconUrl = 'https://promos.goibibo.com/Hotels_product/GI/blueoval.png';

const LOSCard = ({data: {titleText = '', titleTextColor = '', subTextList = []} = {}}) => {
  // Ensure subTextList is always an array, even if it's undefined or null
  const validSubTextList = isValidArray(subTextList) ? subTextList : [];

  const firstTwoSubText = validSubTextList.slice(0, 2);
  const restSubText = validSubTextList.slice(2);

  return (
    <S.LOSCardContainer>
      <S.TextWrapper>
        <S.TitleText titleTextColor={titleTextColor}>{`${titleText}: `}</S.TitleText>
        {firstTwoSubText.length > 0 && (
          <>
            <S.SubText>{`${firstTwoSubText.join(', ')} `} </S.SubText>
            {restSubText.length > 0 && (
              <S.Tooltip>
                <S.TooltipText>+more</S.TooltipText>
                <div className="tooltiptext">
                  <ul>
                    {restSubText.map((item, index) => (
                      <S.SubTextLi key={`${index}_${item}`}>
                        <S.SubTextLiIcon src={defaultIconUrl} />
                        <span>{item}</span>
                      </S.SubTextLi>
                    ))}
                  </ul>
                </div>
              </S.Tooltip>
            )}
          </>
        )}
      </S.TextWrapper>
    </S.LOSCardContainer>
  );
};

export default LOSCard;
